import React, { Fragment, createContext, useReducer, useEffect } from "react";
import { Navber, Footer, CartModal } from "../partials";
import Sidebar from "./Sidebar";
import {
  dashboardUserState,
  dashboardUserReducer,
} from "./DashboardUserContext";
import { fetchData } from "./Action";
 import AutoLogout from "../../AutoLogout";// ✅ Tambahan untuk auto-logout

export const DashboardUserContext = createContext();

const Layout = ({ children }) => {
  const [data, dispatch] = useReducer(dashboardUserReducer, dashboardUserState);

  useEffect(() => {
    fetchData(dispatch);
  }, []);

  return (
    <Fragment>
      <DashboardUserContext.Provider value={{ data, dispatch }}>
        {/* ✅ Auto logout jika user tidak aktif dalam 30 menit */}
        <AutoLogout timeout={30 * 60 * 1000} />

        {/* Wrapper keseluruhan halaman */}
        <div className="min-h-screen flex flex-col">
          {/* Navbar dan modal */}
          <Navber />
          <CartModal />

          {/* Konten utama + sidebar */}
          <main className="flex-1 mx-4 mt-24 md:mx-12 md:mt-32 lg:mt-24 flex flex-col md:flex-row gap-6">
            <Sidebar />
            <div className="flex-1">{children}</div>
          </main>

          {/* Footer */}
          <Footer />
        </div>
      </DashboardUserContext.Provider>
    </Fragment>
  );
};

export default Layout;


